import { ListVersionedProductDto } from './services/api.services';

export interface AppProducts {
  list?: ListVersionedProductDto[];

  Spend?: string;
  Monitor?: string;
  Requests?: string;
  Combined?: string;
  DevTest?: string;
  InsightsMetadata?: string;
};

export const SAVING_OVERLAY_DEBOUNCE_TIME = 2000;
